let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9BboF"), load("ait7e")]).then(() => parcelRequire('ihMq7'));